'use strict';

const COMPONENT_MESSAGE = {
  // From the host iframe
  MOUNT: 'mount-fullscreen-component',
  UNMOUNT: 'unmount-fullscreen-component',
};

angular
  .module('ClinicApp')
  .directive('ocFullscreenComponentManager', (
    IframeService,
    OCLogUtil,
    ClinicConfig,
  ) => ({
    restrict: 'A',
    templateUrl: '/views/directives/oc-fullscreen-component-manager.html',
    link: ($scope) => {
      const debug = ['staging', 'development'].includes(ClinicConfig.ENV);
      const debugLog = (...args) => {
        if (!debug) {
          return;
        }

        console.log('[Fullscreen Component Manager - Clinic-v3]', ...args);
      };

      $scope.components = [];

      IframeService.onMessage(COMPONENT_MESSAGE.MOUNT, (data, sender) => {
        const { instanceId, componentId, props, callbackNames } = data;
        if (!instanceId || !componentId) {
          OCLogUtil.rollbar.error('Tried to mount fullscreen component with missing IDs', { data });
          return;
        }

        const component = {
          instanceId,
          componentId,
          props,
          callbackNames,
          hostWindow: sender.source,
        };

        debugLog('Adding fullscreen component', component);
        $scope.components.push(component);

        $scope.isActive = true;
        $scope.$applyAsync();
      });

      IframeService.onMessage(COMPONENT_MESSAGE.UNMOUNT, (data) => {
        const { instanceId } = data;
        if (!instanceId) {
          OCLogUtil.rollbar.error('Tried to unmount fullscreen component with no instance ID', { data });
          return;
        }

        const componentIndex = $scope.components.findIndex((c) => c.instanceId === instanceId);
        if (componentIndex === -1) {
          OCLogUtil.rollbar.error('Tried to unmount fullscreen component that was not mounted', { data });
          return;
        }

        debugLog('Removing fullscreen component', { instanceId });

        $scope.components.splice(componentIndex, 1);
        $scope.$applyAsync();
      });
    },
  }));
